module.exports = __webpack_public_path__ + "img/Anschnallen.166ffcb9.svg";